export const generateRequestOptions = (method: string, abortSignal: AbortSignal): RequestInit => ({
  method,
  mode: 'cors',
  credentials: 'include',
  signal: abortSignal,
});
